import { isAndroid } from 'react-device-detect'

export const handleCopyClipBoard = async (value: string) => {
  try {
    if (isAndroid) {
      const textarea = document.createElement('textarea')
      textarea.value = value
      textarea.style.position = 'fixed'

      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    } else {
      await window.navigator.clipboard.writeText(value)
    }
  } catch (err: unknown) {
    throw err
  }
}
